import { SizeInfoAction } from './constants';
import { SizeInfoActionType, SizeInfoChannelMessage, SizeInfoPayloadMap } from './types';

// ✨ Action을 추가했다면 여기서 반드시 검증 로직을 구현해야 합니다. (컴파일 에러 발생)
const payloadValidators: {
  [K in SizeInfoActionType]: (payload: unknown) => payload is SizeInfoPayloadMap[K];
} = {
  [SizeInfoAction.AGREE_SIZE_INFO]: (payload): payload is SizeInfoPayloadMap['AGREE_SIZE_INFO'] =>
    typeof payload === 'object' && payload !== null && typeof (payload as any).is_agreed === 'boolean',
  [SizeInfoAction.SELECT_MY_PURCHASE]: (payload): payload is SizeInfoPayloadMap['SELECT_MY_PURCHASE'] =>
    typeof payload === 'object' &&
    payload !== null &&
    typeof (payload as any).catalog_product_id === 'string' &&
    typeof (payload as any).unique_key === 'string',
  [SizeInfoAction.COMPARE_DIRECT_INPUT]: (payload): payload is SizeInfoPayloadMap['COMPARE_DIRECT_INPUT'] =>
    typeof payload === 'object' && payload !== null && Array.isArray((payload as any).measurements),
  [SizeInfoAction.BODY_PROFILE_UPDATED]: (payload): payload is SizeInfoPayloadMap['BODY_PROFILE_UPDATED'] =>
    typeof payload === 'object' && payload !== null,
};

// 런타임에 메시지 객체가 유효한지 검증합니다.
export function isSizeInfoChannelMessage(data: unknown): data is SizeInfoChannelMessage {
  if (!data || typeof data !== 'object') return false;

  const { action, payload } = data as Record<string, unknown>;

  if (typeof action !== 'string') return false;

  // 정의된 액션인지 확인
  if (!Object.values(SizeInfoAction).includes(action as SizeInfoActionType)) {
    return false;
  }

  const actionType = action as SizeInfoActionType;
  const validator = payloadValidators[actionType];

  if (!validator) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[SizeInfoChannel] No validator found for action: ${actionType}`);
    }
    return false;
  }

  // 해당 액션의 페이로드 검증 실행
  return validator(payload);
}
